import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#1A1514]">
        <Loader2 className="w-8 h-8 text-[#B85C38] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  if (!user.is_admin) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#1A1514] text-center px-6">
        <p className="font-display text-2xl text-[#FBF9F6]">Acceso no autorizado</p>
        <p className="text-[#9A8F88] mt-3">Tu cuenta ({user.email}) no tiene permisos de administrador.</p>
        <a href="/admin/login" className="text-[#B85C38] mt-6 underline">Volver</a>
      </div>
    );
  }
  return children;
}
